import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Intent } from "@/model";
import intentRepository from "@/repository/intentRepository";
import { selectorQueryKeys } from "@/query/selector";
import { intentQueryKeys } from "./keys";


export const useDeleteIntent = (agentId: number, skillId?: number, intentId?: string) => {
    const queryClient = useQueryClient();

    return useMutation<Intent, AxiosError>({
        mutationKey: ["intent", 'agent', agentId, "skill", skillId, "intent", intentId, "delete"],
        mutationFn: async () => {
            try {
                const res = await intentRepository.delete(agentId, skillId!, intentId!);
                return res.data.data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: intentQueryKeys.intents(agentId, skillId)
            });
            await queryClient.invalidateQueries({
                queryKey: intentQueryKeys.names(agentId),
                refetchType: "all"
            });
            await queryClient.invalidateQueries({
                queryKey: selectorQueryKeys.pageAll(agentId),
                refetchType: "all"
            });
        }
    });
};
